import { memo } from 'react';
import styled from 'styled-components';
import { HiOutlineTrash } from 'react-icons/hi';

import theme from '@styles/theme';
import { HeaderType } from '@utils/types';

import * as E from '@pages/Equipment/Equipment.style';
import { FlexBox, RegularFont } from '@components/styled/StyledComponents';
import { TableCell } from '@components/share/Table/table.style';
import StyledDnDList from '@components/styled/StyledDnDList';
import StyledRadio from '@components/styled/StyledRadio';

type NoticeListRowProps = {
    index: number;
    header: HeaderType[];
    data: any;
    onChange: (radioKey: string, value: number) => void;
    onDelete: (id: number) => void;
    radioGroup: Record<string, boolean>;
    radioKey: string;
    moveList: (id: number, to: number) => void;
    findList: (id: number) => { list: any; index: number };
};
const NoticeListRow = ({
    index,
    header = [],
    data,
    onChange,
    onDelete,
    radioGroup,
    radioKey,
    moveList,
    findList
}: NoticeListRowProps) => {
    return (
        <StyledDnDList
            id={data?.id as number}
            index={index}
            moveList={moveList}
            findList={findList}
            handlerMinWidth={header[0].minWidth}
            handlerWidth={header[0].width as number}
            gap={20}
            ARROW
        >
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                <Context>{data?.notice || '-'}</Context>
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                <FlexBox $gap={20}>
                    {[
                        { name: '사용', value: 1 },
                        { name: '미사용', value: 0 }
                    ].map((option, index) => (
                        <StyledRadio
                            key={`${index}-${radioKey}`}
                            name={`${radioKey}`}
                            radioId={`${radioKey}-${option.value}`}
                            label={option.name}
                            value={option.value}
                            checked={
                                radioGroup[radioKey] === true
                                    ? 1
                                    : radioGroup[radioKey] === false
                                    ? 0
                                    : null
                            }
                            onChange={(e) =>
                                onChange(radioKey, +e.target.value)
                            }
                        />
                    ))}
                </FlexBox>
            </TableCell>
            <TableCell
                $minWidth={header[3].minWidth}
                $width={header[3].width}
                $fontColor={theme.colors.deepGrayFontColor}
            >
                <Button onClick={() => onDelete(data.id)}>
                    <HiOutlineTrash size={20} color={theme.colors.activePink} />
                </Button>
            </TableCell>
        </StyledDnDList>
    );
};

export default memo(NoticeListRow);

const Context = styled(RegularFont)`
    white-space: pre-wrap;
`;
const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
`;
